import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Column, Container } from 'web-ui-components/lib/global/layout';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { BackButton } from 'web-ui-components/lib/molecules/navigation';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { ButtonGroup } from 'web-ui-components/lib/molecules/buttons';
import { getBrandId } from '../../../states/envConfig/selectors';
import { getMandateToView, getIsMandateEditable } from '../../../states/managePayments/selectors';
import content, { contentPropTypes } from '../../content/ManagePayment.content';
import withContent from '../../../containers/withContent';
import { withScrollTop } from '../../../containers/withScrollTop';
import {
	MANDATE_TYPE_SCHEDULE_PAYMENT,
	MANDATE_TYPE_STANDING_ORDER,
	MANDATE_TYPE_DIRECT_DEBIT,
	MANDATE_TYPE_BACS_CREDIT,
	MANDATE_TYPE_BACS_DEBIT,
	MANDATE_TYPE_SCHEDULE_TRANSFER,
	MANDATE_TYPE_IFT,
	MANDATE_TYPE_CHAPS,
} from '../../../config';
import ViewSchedulePayment from './ViewSchedulePayment';
import ViewStandingOrder from './ViewStandingOrder';
import ViewDirectDebit from './ViewDirectDebit';
import ViewBacsCredit from './ViewBacsCredit';
import ViewBacsDebit from './ViewBacsDebit';
import ViewIFTPayment from './ViewIFTPayment';
import ViewChapsPayment from './ViewChapsPayment';

const mapState = (state) => ({
	mandate: getMandateToView(state),
	isMandateEditable: getIsMandateEditable(state),
	brandId: getBrandId(state),
});

export const ViewPayment = ({
	mandate,
	content,
	handleEdit,
	handleCancelView,
	handleBack,
	isMandateEditable,
	brandId,
}) => {
	const renderDetails = () => {
		const componentToRender = {
			[MANDATE_TYPE_SCHEDULE_TRANSFER]: (
				<ViewSchedulePayment mandate={mandate} viewScheduleHeader={content.OneOffPaymenttype} />
			),
			[MANDATE_TYPE_SCHEDULE_PAYMENT]: (
				<ViewSchedulePayment mandate={mandate} viewScheduleHeader={content.OneOffPaymenttype} />
			),
			[MANDATE_TYPE_STANDING_ORDER]: <ViewStandingOrder mandate={mandate} brandId={brandId} />,
			[MANDATE_TYPE_DIRECT_DEBIT]: <ViewDirectDebit mandate={mandate} brandId={brandId} />,
			[MANDATE_TYPE_BACS_CREDIT]: <ViewBacsCredit mandate={mandate} brandId={brandId} />,
			[MANDATE_TYPE_BACS_DEBIT]: <ViewBacsDebit mandate={mandate} brandId={brandId} />,
			[MANDATE_TYPE_IFT]: <ViewIFTPayment mandate={mandate} header={content.iftPaymentHeader} brandId={brandId} />,
			[MANDATE_TYPE_CHAPS]: (
				<ViewChapsPayment mandate={mandate} header={content.chapsPaymentHeader} brandId={brandId} />
			),
		}[mandate.mandateType];
		return componentToRender;
	};
	const { viewPaymentHeader, backButtonLabel, editButtonLabel, cancelButtonLabel, cancelPaymentButtonLabel } = content;
	const cancelLabel = MANDATE_TYPE_CHAPS === mandate.mandateType ? cancelPaymentButtonLabel : cancelButtonLabel;

	return (
		<Container>
			<BackButton onClick={handleBack} />
			<PageHeading data-test-id="view-payment-container">{viewPaymentHeader}</PageHeading>
			<Row>
				<Column sm={24} md={18}>
					{renderDetails()}
				</Column>
			</Row>
			<div className="u-margin-top-2">
				<ButtonGroup>
					<Button
						id={`back-button-${mandate.id}`}
						display="secondary"
						className="u-margin-right-1"
						onClick={handleBack}
					>
						{backButtonLabel}
					</Button>
					{isMandateEditable && (
						<Button
							id={`edit-button-${mandate.id}`}
							display="secondary"
							className="u-margin-right-1"
							onClick={() => handleEdit(mandate)}
						>
							{editButtonLabel}
						</Button>
					)}
					<Button
						id={`cancel-button-${mandate.id}`}
						className="u-margin-right-1"
						display="primary"
						onClick={() => handleCancelView(mandate)}
					>
						{cancelLabel}
					</Button>
				</ButtonGroup>
			</div>
		</Container>
	);
};
ViewPayment.propTypes = {
	mandate: PropTypes.shape({
		fromAccount: PropTypes.shape({
			displayName: PropTypes.string.isRequired,
		}),
		display_name: PropTypes.string,
		reference: PropTypes.string.isRequired,
	}),
	handleEdit: PropTypes.func.isRequired,
	handleCancelView: PropTypes.func.isRequired,
	handleBack: PropTypes.func.isRequired,
	content: PropTypes.shape(contentPropTypes),
	isMandateEditable: PropTypes.bool.isRequired,
};

const contentWrapper = withContent({ content })(ViewPayment);
export default connect(mapState)(withScrollTop(contentWrapper));
